import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { RootState } from 'Douleutaras/redux/store';
import { Me } from 'Douleutaras/types';

export interface UserSummary {
  loading: boolean;
  error: boolean;
  me: {
    attributes: Me;
    id: string;
    type: string;
  };
}

export const getMe = createAsyncThunk(
  'user/me',
  async (arg = undefined, api) => {
    const response = await makeRequest(
      'api/public/v3/user/me',
      {
        method: 'GET'
      }
    )(api);

    if (response?.status === 200) {
      return response.data;
    }

    return api.rejectWithValue(response);
  }
);

export const getProStripeOnBoardingLink = createAsyncThunk(
  'user/me/stripeOnboardingLink',
  async (arg, api) => {
    const response = await makeRequest(
      'api/public/v3/user/me/stripe_onboarding_link',
      {
        method: 'POST'
      }
    )(api);

    if (response.status === 200) {
      return response.data.data.onboarding_link;
    }

    return api.rejectWithValue(response?.payload?.response.data.errors);
  }
);

export const meSlice = createSlice({
  name: 'me',
  initialState: {
    loading: true,
    error: false,
    me: {}
  } as UserSummary,
  reducers: {
    changeMeAnonymizeStatus: (state, action) => {
      state.me.attributes = {
        ...state.me.attributes,
        anonymizationRequested: action.payload
      };
    }
  },
  extraReducers: builder => {
    builder.addCase(getMe.fulfilled, (state, action) => {
      state.me = action.payload.data;
      state.loading = false;
      state.error = false;
    });
    builder.addCase(getMe.rejected, state => {
      state.loading = false;
      state.error = true;
    });
  }
});

export const { changeMeAnonymizeStatus } = meSlice.actions;
export const selectMe = (state: RootState): Me => state.me.me.attributes;
export const selectMeId = (state: RootState): string => state.me.me.id;
export const selectMeLoading = (state: RootState): boolean => state.me.loading;
export default meSlice;
